/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import { INotification } from '../types/notifications';

interface INotificationsState {
  notifications: INotification[];
}

const initialState = {
  notifications: [],
} as INotificationsState;

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    addNotification(state, action) {
      state.notifications.push(action.payload);
    },
    removeNotification(state, action) {
      state.notifications = state.notifications.filter(({ id }) => id !== action.payload);
    },
  },
});

export const { addNotification, removeNotification } = notificationsSlice.actions;

export default notificationsSlice.reducer;
